import React, { useEffect } from 'react'
import { getUrl } from 'aws-amplify/storage'
import './section-builder.scss'

const SectionBuilder = ({ id, style, imageKey, handleClick, onUpdate, children }) => {
  const heroMainId = 'hero-main'

  useEffect(() => {
    let isMounted = true
    const getS3Image = async (key) => {
      try {
        const { url } = await getUrl({
          key: key.replace(/^\/+/, ''),
          options: {
            accessLevel: 'public',
          },
        })
        if (isMounted) {
          onUpdate(id, {
            style: {
              backgroundImage: `url(${url.toString()})`,
            },
          })
        }
      } catch (err) {
        console.error('Failed to load S3 background image', err)
      }
    }
    if (imageKey && !style?.backgroundImage) {
      getS3Image(imageKey)
    }
    return () => {
      isMounted = false
    }
  }, [imageKey, style?.backgroundImage, id, onUpdate])

  return (
    <div
      className={id === heroMainId ? 'hero-section-builder' : 'section-builder'}
      style={style}
      onClick={(e) => {
        e.stopPropagation()
        handleClick()
      }}
    >
      {children}
    </div>
  )
}

export default SectionBuilder

